const SPACES = {
  headerHeight: '58px',
};
export default SPACES;
